export default function NotFound({ className }) {
  return (
    <div className={className}>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </div>
  );
}